<div class="card-topic-section__card">
  <div class="card-topic-section__card__content">
    @if (card.imgSrc) {
      <div class="card-topic-section__card__img">
        <img [src]="card.imgSrc" [alt]="card.title" style="width: auto" />
      </div>
    }
    @if (card.title) {
      <div class="card-topic-section__card__title">
        {{ card.title }}
      </div>
    }
    @if (card.description) {
      <div class="card-topic-section__card__description">
        {{ card.description }}
      </div>
    }
  </div>
</div>
